
export const GENERAL_TIMEFRAME_EMPTY = [
    {
        dayOfWeek: "Monday",
        isOpen: false,
        opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Tuesday",
        isOpen: false,
        opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Wednesday",
        isOpen: false,
         opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Thursday",
        isOpen: false,
         opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Friday",
        isOpen: false,
         opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Saturday",
        isOpen: false,
         opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    },
    {
        dayOfWeek: "Sunday",
        isOpen: false,
         opening: null,
        breakFrom: null,
        breakTo: null,
        closing: null
    }
]

export const DMS_LOCATION_TYPES= [
    {
        code: 'APT',
        description: 'Airport'
    },
    {
        code: 'FFSS',
        description: 'Railway Station'
    },
    {
        code: 'DTN',
        description: 'Downtown'
    },
    {
        code: 'PRT',
        description: 'Seaport'
    }
];